"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function setPlayAnimation(playing) {
    return {
        type: types_1.SET_PLAY_ANIMATION_VALUE,
        payload: {
            playing: playing
        }
    };
}
exports.setPlayAnimation = setPlayAnimation;
function resetPlayAnimation() {
    return {
        type: types_1.RESET_PLAY_ANIMATION_VALUE
    };
}
exports.resetPlayAnimation = resetPlayAnimation;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/animation-playing/actions.ts
// module id = 369
// module chunks = 5